import { memo } from "react";
import "./ChristmasTheme.scss";

const ChristmasTheme = memo(() => {
  return (
    <>
      <div className="snowflakes"/>
      <div className="santa"/>
    </>
  );
});

export default ChristmasTheme;
